import { createContext, useContext, useState } from 'react'

import { YesObject } from '@yes.technology/react-toolkit'

export type SelectAndLinkData = {
  uuidObjectclass: string
  callback: (values: YesObject[]) => void
  uniselection?: boolean
  selectedObjects?: Pick<YesObject, 'uuid' | 'des'>[]
}

export type SelectAndLinkFrameContextType = {
  selectAndLinkData: SelectAndLinkData | null
  setSelectAndLinkData: (data: SelectAndLinkData | null) => void
}

export const SelectAndLinkFrameContext =
  createContext<SelectAndLinkFrameContextType>({
    selectAndLinkData: null,
    setSelectAndLinkData: () => {}
  })

export const SelectAndLinkFrameContextProvider = ({
  children
}: React.PropsWithChildren) => {
  const [selectAndLinkData, setSelectAndLinkData] =
    useState<SelectAndLinkData | null>(null)

  return (
    <SelectAndLinkFrameContext.Provider
      value={{
        selectAndLinkData,
        setSelectAndLinkData
      }}
    >
      {children}
    </SelectAndLinkFrameContext.Provider>
  )
}

export const useSelectAndLinkFrameContext = () =>
  useContext(SelectAndLinkFrameContext)
